import { ERequestApiStatus, EWsClientEventType } from '../../types/appState';
import { TThunkAction } from '../../types/redux/thunk';
import { createWsMessage } from '../../utils/message';
import { setSendMessageFailed } from '../sendMessage';

/**
 * Обработка неуспешного открытия канала WS:
 * помечает все pending-события как Failed и отображает кнопку повтора для сообщений
 */
export const openEventChannelFailed =
  (): TThunkAction<void> =>
  (dispatch, _getState, { custom: { messagesMap, socket } }) => {
    if (!socket) {
      return;
    }

    const { clientEvents } = socket;

    for (const [key, value] of clientEvents.entries()) {
      if (value.status === ERequestApiStatus.Pending) {
        clientEvents.set(key, { ...value, status: ERequestApiStatus.Failed });

        if (value.type === EWsClientEventType.Message) {
          const messageItem = messagesMap.get(key);

          if (messageItem) {
            const {
              message: {
                message: { message: text, userId },
                chatId,
              },
            } = messageItem;

            const message = createWsMessage({ text, chatId, userId });
            dispatch(setSendMessageFailed({ message, messageId: key, messagesMap }));
          }
        }
      }
    }
  };
